import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IVesselInformationMySuffix } from 'src/app/shared/model/vessel-information-my-suffix.model';
import { VesselInformationMySuffixService } from './vessel-information-my-suffix.service';

@Component({
    selector: 'jhi-vessel-information-my-suffix-update',
    templateUrl: './vessel-information-my-suffix-update.component.html'
})
export class VesselInformationMySuffixUpdateComponent implements OnInit {
    private _vesselInformation: IVesselInformationMySuffix;
    isSaving: boolean;

    constructor(private vesselInformationService: VesselInformationMySuffixService, private activatedRoute: ActivatedRoute) {}

    ngOnInit() {
        this.isSaving = false;
        this.activatedRoute.data.subscribe(({ vesselInformation }) => {
            this.vesselInformation = vesselInformation;
        });
    }

    previousState() {
        window.history.back();
    }

    save() {
        this.isSaving = true;
        if (this.vesselInformation.id !== undefined) {
            this.subscribeToSaveResponse(this.vesselInformationService.update(this.vesselInformation));
        } else {
            this.subscribeToSaveResponse(this.vesselInformationService.create(this.vesselInformation));
        }
    }

    private subscribeToSaveResponse(result: Observable<HttpResponse<IVesselInformationMySuffix>>) {
        result.subscribe(
            (res: HttpResponse<IVesselInformationMySuffix>) => this.onSaveSuccess(),
            (res: HttpErrorResponse) => this.onSaveError()
        );
    }

    private onSaveSuccess() {
        this.isSaving = false;
        this.previousState();
    }

    private onSaveError() {
        this.isSaving = false;
    }
    get vesselInformation() {
        return this._vesselInformation;
    }

    set vesselInformation(vesselInformation: IVesselInformationMySuffix) {
        this._vesselInformation = vesselInformation;
    }
}
